module.exports = __webpack_public_path__ + "img/www.sitejabber.com.4a6c8fcc.png";